import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useLeftBar } from "../../context/LeftBar";
import NavItem from "./MenuItem/NavItem";
import VendeuGanhouLogo from "../../assets/img/logo-vendeu-ganhou.png";
import { ReactComponent as MenuArrow } from "../../assets/icons/circle-arrow.svg";
import { ReactComponent as OverviewIcon } from "../../assets/icons/overview.svg";
import { ReactComponent as GridsOutlinedIcon } from "../../assets/icons/grids-outlined.svg";
import { ReactComponent as InsightsTimelineIcon } from "../../assets/icons/insights-timeline.svg";
import { Box, Grid } from "@mui/material";
import ExcellenceLogoFooter from "../../assets/img/logo-footer-excellence.png";

function LeftSideMenu({ app, config, logo }) {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [dataAtualizacao, setDataAtualizacao] = useState("");

  async function initialSelecao() {
    await app.variable.getContent("vAtualizacao", (reply) => {
      const data = reply.qContent.qString;
      setDataAtualizacao(data.substring(0, 10));
    });
  }

  useEffect(() => {
    initialSelecao();
    window.addEventListener("resize", () => setScreenWidth(window.innerWidth));

    return () => {
      window.removeEventListener("resize", () =>
        setScreenWidth(window.innerWidth)
      );
    };
  }, []);

  const { leftBarOpened, setLeftBarOpened } = useLeftBar();
  return (
    <div className={leftBarOpened ? "leftSideMenu is-opened" : "leftSideMenu"}>
      <Grid
        container
        flexDirection={"row"}
        justifyContent={"center"}
        alignItems={"center"}
        className="leftSideHeader"
      >
        <Grid item className={leftBarOpened ? "logo" : "logo is-hidden"} xs>
          <Box
            component={"img"}
            src={VendeuGanhouLogo}
            style={{ height: "auto" }}
          />
        </Grid>
      </Grid>
      <div className="leftSideDivider">
        <button
          type="button"
          onClick={() => {
            setLeftBarOpened(!leftBarOpened);
          }}
        >
          <MenuArrow
            className={`toggle-arrow${leftBarOpened ? "" : " is-closed"}`}
          />
        </button>
      </div>
      <Grid
        container
        direction={"column"}
        justifyContent={"center"}
        alignItems={"flex-start"}
        rowGap={4}
        className="leftSideContent"
      >
        <Grid
          container
          direction={"column"}
          justifyContent={"center"}
          alignItems={"flex-start"}
          rowGap={2.5}
        >
          {leftBarOpened && <h2 className="title">CAMPANHA DE INCENTIVO</h2>}
          <Grid
            className={leftBarOpened ? "content" : "closed-bar"}
            container
            direction={"column"}
            justifyContent={"center"}
            alignItems={"flex-start"}
            item
            xs
          >
            <ul>
              <NavItem
                muiIcon={<OverviewIcon />}
                name="Visão Geral"
                path="/overview"
              />
            </ul>
            <ul>
              <NavItem
                muiIcon={<GridsOutlinedIcon />}
                name="Detalhamento"
                path="/details"
              />
            </ul>
            <ul>
              <NavItem
                muiIcon={<InsightsTimelineIcon />}
                name="Oportunidades"
                path="/opportunities"
              />
            </ul>
          </Grid>
        </Grid>
      </Grid>

      {leftBarOpened && (
        <Grid
          flexDirection={"column"}
          alignItems={"flex-start"}
          columnGap={1}
          className="leftSideFooter"
        >
          <Grid item>
            <Box
              component={"img"}
              src={ExcellenceLogoFooter}
              className="container-img-leftSide"
            />
          </Grid>
          <Grid item>
            <p>Atualizado em: {dataAtualizacao}</p>
          </Grid>
        </Grid>
      )}
    </div>
  );
}

LeftSideMenu.defaultProps = {
  app: null,
  config: null,
  logo: null,
};

LeftSideMenu.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
  logo: PropTypes.object,
};

export default LeftSideMenu;
